import path, { createRouteObject } from 'Router/path'
import component from 'Components/index'
import { RouteRecordRaw } from 'vue-router';

const router: RouteRecordRaw[] = [
    createRouteObject({
        path: path.customerCredit,
        component: component.CustomerCreditLandingPage
    }),
    createRouteObject({
        path: path.customerCreditDetail,
        component: component.CustomerCreditDetailPage
    }),
    createRouteObject({
        path: path.customerList,
        component: component.CustomerLandingPage
    }),
    createRouteObject({
        path: path.customerForm,
        component: component.CustomerFormPage
    }),
    createRouteObject({
        path: path.customerDetail, 
        component: component.CustomerDetailPage
    })
]
export default router;